import RoutingTabs from "./RoutingTabs";
import "./Style.scss";

export { RoutingTabs };
